import React, { useEffect } from 'react'
import { Button, Col, Modal, Form, notification, Row } from 'antd'
import { connect } from 'react-redux'
import { useDispatch } from 'react-redux'
import { updateUnizhomePolicyFxn } from '../action'
import GetEachFormFields from '../../../components/_utils/appFormUtils'

const EditPaymentPolicy = (props) => {
  let dispatch = useDispatch()
  let {
    visible,
    onClose,
    form: { getFieldDecorator, setFieldsValue },
    propertyId,
    policy,
    onSubmit,
    policyType
  } = props
  const setDefaultValues = () => {
    setTimeout(() => {
      setFieldsValue({
        name: policy.name,
        display_name: policy.display_name,
        short_text: policy.short_text || '',
        value: policy.value
      })
    }, 100)
  }
  let inputTypes = {
    fields: [
      {
        key: 'name',
        label: 'Name',
        placeholder: 'Edit Name',
        type: 'text',
        required: true,
        span: 12
      },
      {
        key: 'display_name',
        label: 'Display Name',
        placeholder: 'Edit Display Name',
        type: 'text',
        span: 12
      },
      {
        key: 'short_text',
        label: 'Short Description',
        placeholder: 'Short Description',
        type: 'editor',
        hidden: policyType == 'Description',
        span: 12
      },
      {
        key: 'value',
        label: 'Description',
        placeholder: 'Edit Description',
        type: 'editor',
        required: true,
        rows: 4,
        span: policyType == 'Description' ? 24 : 12
      }
    ]
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const { form } = props
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        const updatedFaq = {
          ...valData,
          policyId: policy._id,
          propertyId
        }
        const resp = await dispatch(updateUnizhomePolicyFxn(updatedFaq))
        if (resp && resp.success) {
          onSubmit()
        }
      } else {
        notification.warning({
          message: 'Please fill in all required fields'
        })
      }
    })
  }


  useEffect(() => {
    setDefaultValues()
  }, [])

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onClose}
        title={`Edit ${policyType}`}
        width={'85%'}
        footer={null}>
        <div className='form-box commissionBox'>
          <div className='card'>
            <Form onSubmit={handleSubmit}>
              <Row gutter={24} className={'wrapBox'}>
                {inputTypes.fields.map((item, key) => {
                  return (
                    <React.Fragment key={key}>
                      <Col span={item.span ? item.span : 24} key={key}>
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={{
                            labelCol: { xs: { span: 0 }, sm: { span: 0 } },
                            wrapperCol: { xs: { span: 24 } }
                          }}
                        />
                      </Col>
                    </React.Fragment>
                  )
                })}
                <Col span={4}>
                  <Form.Item>
                    <Button
                      type='primary' htmlType='submit' className={'btn mt40'}>
                      Update
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  )
}

const EditPaymentPolicyModal = Form.create()(EditPaymentPolicy)

const mapStateToProps = ({ global, router }) => ({
  currentUser: global.currentUser
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPaymentPolicyModal)
